<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import type { PrimitiveProps } from 'reka-ui';
import { Primitive } from 'reka-ui';
import { cn } from '@/lib/utils';
import type { BadgeVariants } from '.';
import { badgeVariants } from '.';

const props = defineProps<
    PrimitiveProps &
        (
            | {
                  variant?: BadgeVariants['variant'];
                  color?: never;
                  class?: HTMLAttributes['class'];
              }
            | {
                  variant: 'secondary';
                  color?: BadgeVariants['color'];
                  class?: HTMLAttributes['class'];
              }
        )
>();

const delegatedProps = reactiveOmit(props, 'class');
</script>

<template>
    <Primitive
        data-slot="badge"
        :class="cn(badgeVariants({ variant, color }), props.class)"
        v-bind="delegatedProps"
    >
        <slot />
    </Primitive>
</template>
